import React from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Mutation } from 'react-apollo';
import { FormattedMessage } from 'react-intl';
import { CustomButton } from '../../containers';
import { DeleteUserMutation } from '../../operations/mutations/DeleteUserMutation';
import { handleRequestError } from '../../constants/errorCodes';
import { renderToaster, SUCCESS_TOASTER } from '../../constants/toaster';
import { redirectToAdminEmployeeListPage, redirectToAdminUserListPage } from '../../redux/actions/navigationActions';

export const ConfirmUserDeleteModal = ({ isOpen, toggle, user, employee }) => {
  const dispatch = useDispatch();
  const person = employee ? 'employee' : 'user';

  const capitalize = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  return (
    <Modal modalClassName="hok-modal" centered size="sm" backdrop="static" toggle={toggle} isOpen={isOpen}>
      <ModalHeader className="border-0">
        <Row className="no-gutters auth-nav-links">
          <Col xs={12}>
            <h2 className="d-flex align-items-center justify-content-center">
              <FormattedMessage id={`adminEdit${capitalize(person)}Page.removeTitle`} />
            </h2>
          </Col>
        </Row>
      </ModalHeader>
      <ModalBody>
        <Row className="no-gutters px-4 pt-3 pb-1 font-weight-500">
          <Col xs="12" className="text-center">
            <FormattedMessage id={`adminEdit${capitalize(person)}Page.areYouSureToRemove${capitalize(person)}`} />
          </Col>
        </Row>
        <Row className="no-gutters pt-0 px-4 pt-0 pb-3 font-weight-400">
          <Col xs="12" className="text-center">
            <FormattedMessage id={`adminEdit${capitalize(person)}Page.areYouSureToRemove${capitalize(person)}Notice`} />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Row className="w-100">
          <Col xs={6}>
            <CustomButton className="hok-outline-btn" outline translationId="no" onClick={toggle} />
          </Col>
          <Col xs={6}>
            <Mutation
              mutation={DeleteUserMutation}
              onError={error => handleRequestError(error, dispatch)}
              onCompleted={() => {
                renderToaster(`successMessages.${person}Deleted`, SUCCESS_TOASTER, { intlKey: true });
                if (employee) {
                  dispatch(redirectToAdminEmployeeListPage());
                } else {
                  dispatch(redirectToAdminUserListPage());
                }
              }}>
              {(deleteUser, { loading }) => {
                return (
                  <CustomButton
                    type="submit"
                    className="hok-dashboard-btn"
                    translationId="yes"
                    onClick={() => {
                      deleteUser({
                        variables: {
                          id: user.id,
                        },
                      });
                      toggle();
                    }}
                    loaderProp={loading}
                  />
                );
              }}
            </Mutation>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  );
};
